import request from './api'

export class LiveRoomService {
    async getLiveRooms() {
        const response = await request({
            method: 'GET',
            url: `api/fixturerooms/live`
        });

        return response;
    }

    async getCompletedRooms() {
        const response = await request({
            method: 'GET',
            url: `api/fixturerooms/completed`
        });

        return response;
    }

    async endRoom(fixtureRoomId: string, userId: string) {
        const response = await request({
            method: 'POST',
            url: `api/fixturerooms/${fixtureRoomId}/end`,
            data: {
                userId
            }
        });

        return response;
    }

    async syncRoomScore(fixtureRoomId: string) {
        const response = await request({
            method: 'POST',
            url: `api/fixturerooms/${fixtureRoomId}/sync-score`,
            data: { }
        });

        return response;
    }

    async reopenRoom(fixtureRoomId: string) {
        const response = await request({
            method: 'POST',
            url: `api/fixturerooms/${fixtureRoomId}/reopen`,
            data: {}
        });

        return response;
    }

    static get instance() {
        return liveRoomService
    }
}

const liveRoomService = new LiveRoomService();

export default liveRoomService;